





















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AppTabs from './AppTabs.vue';

@Component({
  components: {
    AppTabs,
  }
})
export default class AppNavigationDrawer extends Vue {

  /**
   * Title displayed.
   */
  @Prop({ type: String }) private title!: string;

  /**
   * Value of the navigation drawer.
   */
  @Prop({ required: true }) private value!: boolean;

  private value_ = this.value;

  @Watch('value_')
  private innerValueUpdate() {
    this.$emit('input', this.value_);
  }

  @Watch('value')
  private propValueUpdate() {
    this.value_ = this.value;
  }

}
